/**
 * Layout route for all /encoders/* pages
 * Ensures encoder and live streams data is loaded for child routes (index, triage, detail)
 */
import { useEffect } from 'react';
import { createRoute, Outlet } from '@tanstack/react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { Route as rootRoute } from '../__root';
import { useEncodersStore } from '@/client/store/encodersStore';
import { useLiveStreamsStore } from '@/client/store/liveStreamsStore';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: 'encoders-layout',
  component: EncodersLayout,
});

function EncodersLayout() {
  const { getAccessTokenSilently, logout } = useAuth0();
  const fetchEncoders = useEncodersStore((s) => s.fetchEncoders);
  const fetchLiveStreams = useLiveStreamsStore((s) => s.fetchLiveStreams);

  // Fetch encoders and live streams (store handles caching internally)
  useEffect(() => {
    const loadData = async () => {
      try {
        const token = await getAccessTokenSilently();
        // Both store functions skip fetch if data already cached
        await Promise.all([
          fetchEncoders(token, logout),
          fetchLiveStreams(token, logout),
        ]);
      } catch (err) {
        console.error('Error fetching data in encoders layout:', err);
      }
    };
    loadData();
  }, [getAccessTokenSilently, fetchEncoders, fetchLiveStreams, logout]);

  return <Outlet />;
}
